import { render } from "./ServicesArea.vue?vue&type=template&id=694e7a03"
import script from "./ServicesArea.vue?vue&type=script&lang=js"
export * from "./ServicesArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__